import { render, staticRenderFns } from "./joint-partner.vue?vue&type=template&id=bf1442f0&"
import script from "./joint-partner.vue?vue&type=script&lang=js&"
export * from "./joint-partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports